import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

import { DefaultSheet, SheetBody, DropdownMenuItem } from 'twyne-new.ui';

import { useGlobalStore } from '@Stores/global';
import appStore from 'stores/app';
import { getDateFormats } from 'utils';

import PageHelpers from './PageHelpers';
import PageVariables from './PageVariables';

import '../../assets/no-tailwind.css';

function PageVariablesModal({ top, bottom }) {
  const { customFields: { getFields }, metaFields: { getFields: getMetaFields } } = useGlobalStore()
  const [fields, setFields] = useState([])
  const [open, setOpen] = useState(false)

  const loadFields = useCallback(async () => {
    const fields = await appStore.getFields()
    const customFields = await getFields({ parse: true })
    const metaFields = await getMetaFields()

    const extraFields = []
    for (const customField of customFields) {
      if (customField.private) {
        continue
      }

      extraFields.push(customField.key)
      if (customField.type === 'date') {
        extraFields.push(...getDateFormats(customField.key))
      }
    }

    for (const metaField of metaFields) {
      extraFields.push(metaField.key)
    }

    const allFields = [...fields, ...extraFields].reduce((fields, field) => {
      if (field.endsWith('_urlencoded') || field.startsWith('cf_')) {
        field = field.replace('_urlencoded', '')
        const opts = fields[field] = fields[field] || {}
        opts.encodable = true
        opts.bidid = true
        opts.dba = true
        opts.bid = true
      } else if (field.endsWith('_jsescape')) {
        field = field.replace('_jsescape', '')
        const opts = fields[field] = fields[field] || {}
        opts.escapable = true
      } else if (field.endsWith('_md5')) {
        field = field.replace('_md5', '')
        const opts = fields[field] = fields[field] || {}
        opts.md5 = true
      } else if (field.endsWith('_optout')) {
        field = field.replace('_optout', '')
        const opts = fields[field] = fields[field] || {}
        opts.optout = true
      } else {
        fields[field] = fields[field] || {}
      }
      return fields
    }, {})

    setFields(Object.entries(allFields));
  }, [getFields, getMetaFields])

  useEffect(() => {
    loadFields()
  }, [loadFields])

  const toggle = useCallback(() => setOpen(open => !open), [])

  const TriggerButton = () => <>
    <DropdownMenuItem
      onSelect={e => e.preventDefault()}
      onClick={toggle}
    >
      Page Variables
    </DropdownMenuItem>
  </>

  return <>
    <DefaultSheet
      title='Help'
      triggerProps={{ asChild: true }}
      trigger={<TriggerButton />}
      wrapperProps={{ open, onOpenChange: open => !open && toggle() }}
    >
      <SheetBody>
        <div className='no-tailwind'>
          {top || null}
          <PageVariables fields={fields} toggle={toggle} />
          <PageHelpers onToggle={toggle} />
          {bottom || null}
        </div>
      </SheetBody>
    </DefaultSheet>
  </>
}

PageVariablesModal.propTypes = {
  top: PropTypes.any,
  bottom: PropTypes.any,
};

export default PageVariablesModal;
